<template>
  <generic-historical
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>
  
<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getWorkflow } from '@/services/configurations/workflow/getWorkflow'
import { getHistoricalByWorkflow } from '@/services/historical/getHistoricalByWorkflow'
import { getHistoricalByWorkflowExcel } from '@/services/historical/getHistoricalByWorkflowExcel'
  
export default {
  name: 'list-approvalworkflow-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 97,
      vuexnamespace: 'historicalApprovalWorkflow',
      headerUrl: 'configurations/approvalworkflows/details',
      breadcrumbs: [],
      ExcelName: `${_.kebabCase(i18n.t('approval_workflow.entity_name') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  mounted () {
    this.breadcrumbs = [
      { 
        url: this.role === 3 ? 'configurationssa' : 'configurations', 
        name: i18n.t('configurations.header') 
      },
      { url: 'configurations/approvalworkflows', name: i18n.t('approval_workflow.header') },
      { paths: ['Nombre'] },
    ]
  },
  computed: { 
    role: function () {
      return this.$store.getters['auth/role']
    },
  },
  methods: {
    getParamsAux: function (data) {
      return { IdFlujoAprobacion: this.$route.params.id }
    },
    getParamsDetalleAux: function (data) {
      return this.getParamsAux(data)
    },
    getDetalleAux: async function (params) {
      return await getWorkflow(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByWorkflowExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByWorkflow(payload, params)
    },
  }
}
</script>
  
  <style lang="scss" scoped></style>
